import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { PermissionEnum } from 'symbols';
import { AccessState } from '../../state/access.state';

@Injectable()
export class RolesGuard {

  constructor(private store: Store) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const requiredRoles: PermissionEnum[] = route.data['roles'] || [];
    const currentRoles = this.store.select(AccessState.currentRoles);

    return currentRoles.pipe(map(roles => roles.some(v => requiredRoles.includes(v))));

  }
}
